document.addEventListener('click', (event) => {
  if( event.target.classList.contains( 'swatch-input__input' ) ) {
    let radioButton = event.target;
    let productCard = radioButton.closest( '.grid__item' );
    let productLinks = productCard.querySelectorAll( 'a' );
    
    let productHref = new URL(productLinks[0].href);
    let linkParams = productHref.searchParams;
    linkParams.set( 'variant', radioButton.dataset.variantId );
    productHref.search = linkParams.toString();
    productLinks.forEach((productLink) =>
      productLink.href = productHref
    );
    
    let activeImages = productCard.querySelectorAll( '.card__media img.active' );
    let newActiveImages = productCard.querySelectorAll( '.image-id-' + radioButton.dataset.variantImageId );
    activeImages.forEach((image) =>
      image.classList.remove( 'active' )
    );
    newActiveImages.forEach((image) =>
      image.classList.add( 'active' )
    );
  }
});

window.addEventListener("load", (event) => {
   _ltk.Signup.New("Footer", "newsletter-email", _ltk.Signup.TYPE.CLICK, ".newsletter-submit", "email");
});